import { axiosObject } from "../config";

export default function register(form: any) {
  let payload = {
    type: "email",
    value: form.value.email.toLocaleLowerCase(),
    password: form.value.password,
  };

  return new Promise((resolve, reject) => {
    let uri = "access/register";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        if (errors.response.status === 422) {
          if (
            errors.response.data.errors.value[0] === "Value should be unique"
          ) {
            form.setErrors({ email: ["Email already registered"] });
            reject(errors.response.data.errors);
          } else {
            reject(errors.response.data.errors);
          }
        }
        reject(errors);
      });
  });
}
